import React from 'react';

// Small inline icon set, reused across admin + list UIs. Inherit color via currentColor.
type IconProps = { size?: number; className?: string };
const base = (size: number, className: string) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  className,
});

export const TrashIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => (
  <svg {...base(size, className)}><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /></svg>
);

export const PencilIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => (
  <svg {...base(size, className)}><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></svg>
);

export const KeyIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => (
  <svg {...base(size, className)}><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" /></svg>
);

export const PlusIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => (
  <svg {...base(size, className)}><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
);

export const CheckIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => (
  <svg {...base(size, className)}><polyline points="20 6 9 17 4 12" /></svg>
);

export const XIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => (
  <svg {...base(size, className)}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);
